// extracted by mini-css-extract-plugin
export default {"newset":"styles_newset__zPE5y"};